import "./case-studies-block.scss";